import React, { useState } from 'react';

function PeriodoSelectionModal({ show, onClose, onConfirm, title, isLoading }) {
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');

  const handleConfirm = () => {
    if (dataInicio && dataFim && onConfirm) {
      // Validar se data início é menor que data fim
      if (new Date(dataInicio) > new Date(dataFim)) {
        alert('Data de início deve ser menor que data de fim');
        return;
      }
      onConfirm(dataInicio, dataFim);
    }
  };

  const handleClose = () => {
    setDataInicio('');
    setDataFim('');
    onClose();
  };

  // Função para obter data no formato YYYY-MM-DD
  const getToday = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  // Função para obter primeiro dia do mês atual
  const getFirstDayOfMonth = () => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    return firstDay.toISOString().split('T')[0];
  };

  // Função para definir período pré-definido
  const setPeriodoPredefinido = tipo => {
    const today = new Date();
    let inicio, fim;

    switch (tipo) {
      case 'mesAtual':
        inicio = new Date(today.getFullYear(), today.getMonth(), 1);
        fim = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case 'mesPassado':
        inicio = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        fim = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      case 'ultimosTrintaDias':
        inicio = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);
        fim = today;
        break;
      case 'anoAtual':
        inicio = new Date(today.getFullYear(), 0, 1);
        fim = today;
        break;
      default:
        return;
    }

    setDataInicio(inicio.toISOString().split('T')[0]);
    setDataFim(fim.toISOString().split('T')[0]);
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header bg-primary py-2">
            <h6 className="modal-title text-white m-0">
              <i className="bi bi-calendar-range me-2"></i>
              {title || 'Selecione o Período'}
            </h6>
            <button
              type="button"
              className="btn-close btn-close-white shadow-sm p-2"
              onClick={handleClose}
              disabled={isLoading}
            ></button>
          </div>
          <div className="modal-body">
            <div className="d-flex align-items-center mb-3">
              <i
                className="bi bi-calendar-check text-primary me-3"
                style={{ fontSize: '2rem' }}
              ></i>
              <div>
                <p className="mb-1">
                  Selecione o período para gerar o relatório de despesas:
                </p>
                <small className="text-muted">
                  O relatório incluirá todas as despesas com data de elaboração
                  no período selecionado.
                </small>
              </div>
            </div>

            {/* Períodos Pré-definidos */}
            <div className="mb-4">
              <label className="form-label fw-bold">
                Períodos Pré-definidos:
              </label>
              <div className="row">
                <div className="col-md-3 col-6 mb-2">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm w-100"
                    onClick={() => setPeriodoPredefinido('mesAtual')}
                    disabled={isLoading}
                  >
                    Mês Atual
                  </button>
                </div>
                <div className="col-md-3 col-6 mb-2">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm w-100"
                    onClick={() => setPeriodoPredefinido('mesPassado')}
                    disabled={isLoading}
                  >
                    Mês Passado
                  </button>
                </div>
                <div className="col-md-3 col-6 mb-2">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm w-100"
                    onClick={() => setPeriodoPredefinido('ultimosTrintaDias')}
                    disabled={isLoading}
                  >
                    Últimos 30 Dias
                  </button>
                </div>
                <div className="col-md-3 col-6 mb-2">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm w-100"
                    onClick={() => setPeriodoPredefinido('anoAtual')}
                    disabled={isLoading}
                  >
                    Ano Atual
                  </button>
                </div>
              </div>
              <hr />
            </div>

            {/* Seleção Manual de Datas */}
            <div className="row">
              <div className="col-md-6">
                <label htmlFor="dataInicio" className="form-label fw-bold">
                  <i className="bi bi-calendar-plus me-1"></i>
                  Data de Início:
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="dataInicio"
                  value={dataInicio}
                  onChange={e => setDataInicio(e.target.value)}
                  disabled={isLoading}
                  max={getToday()}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="dataFim" className="form-label fw-bold">
                  <i className="bi bi-calendar-check me-1"></i>
                  Data de Fim:
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="dataFim"
                  value={dataFim}
                  onChange={e => setDataFim(e.target.value)}
                  disabled={isLoading}
                  min={dataInicio}
                  max={getToday()}
                />
              </div>
            </div>

            {/* Informações do Período Selecionado
            {dataInicio && dataFim && (
              <div className="mt-3 p-3 bg-light rounded">
                <div className="d-flex align-items-center">
                  <i className="bi bi-info-circle text-info me-2"></i>
                  <div>
                    <strong>Período selecionado:</strong>
                    <br />
                    <span className="text-muted">
                      De {new Date(dataInicio).toLocaleDateString('pt-BR')} até{' '}
                      {new Date(dataFim).toLocaleDateString('pt-BR')}
                    </span>
                  </div>
                </div>
              </div>
            )} */}

            {isLoading && (
              <div className="mt-3 p-3 bg-light rounded">
                <div className="d-flex align-items-center">
                  <div
                    className="spinner-border spinner-border-sm text-primary me-2"
                    role="status"
                  >
                    <span className="visually-hidden">Carregando...</span>
                  </div>
                  <div>
                    <span className="text-muted">
                      Gerando relatório para o período selecionado...
                    </span>
                    <br />
                    <small className="text-muted">
                      Por favor, aguarde. O PDF será aberto automaticamente.
                    </small>
                  </div>
                </div>
                <div className="progress mt-2" style={{ height: '3px' }}>
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style={{ width: '100%' }}
                  ></div>
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
              disabled={isLoading}
            >
              <i className="bi bi-x-lg me-1"></i>
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleConfirm}
              disabled={isLoading || !dataInicio || !dataFim}
            >
              {isLoading ? (
                <>
                  <div
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  >
                    <span className="visually-hidden">Carregando...</span>
                  </div>
                  Gerando...
                </>
              ) : (
                <>
                  <i className="bi bi-file-earmark-pdf me-1"></i>
                  Gerar Relatório
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PeriodoSelectionModal;
